<script setup>
// "Approved | Pending (n)" under the FAQs header (phase 4.3, D-P5): the kit's line tabs, each one the route it has
// today (/faqs, /faqs/pending). The count is the store's pending count, fetched here for the current assistant, so
// both pages show the same number. It replaces the blue "N pending FAQs" banner.
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import { useNumberFormatter } from 'shared/composables/useNumberFormatter';
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from 'dashboard/components-next/polaris/ui/tabs';

const APPROVED = 'polaris_assistants_responses_index';
const PENDING = 'polaris_assistants_responses_pending';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const store = useStore();
const { formatFullNumber } = useNumberFormatter();
const pendingCount = useMapGetter('polarisResponses/getPendingCount');

const assistantId = computed(() => route.params.assistantId);
watch(
  assistantId,
  id => {
    if (id) store.dispatch('polarisResponses/fetchPendingCount', id);
  },
  { immediate: true }
);

const go = name => {
  if (name !== route.name) router.push({ name, params: route.params });
};
</script>

<template>
  <Tabs :model-value="route.name" class="shrink-0" @update:model-value="go">
    <TabsList
      variant="line"
      class="px-6"
      :aria-label="t('POLARIS.PAGES.RESPONSES_TABS.LABEL')"
    >
      <TabsTrigger :value="APPROVED">
        {{ t('POLARIS.PAGES.RESPONSES_TABS.APPROVED') }}
      </TabsTrigger>
      <TabsTrigger :value="PENDING">
        {{
          t('POLARIS.PAGES.RESPONSES_TABS.PENDING', {
            count: formatFullNumber(pendingCount),
          })
        }}
      </TabsTrigger>
    </TabsList>
  </Tabs>
</template>
